import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUpRight, X, Quote, Sparkles } from 'lucide-react';
import { FaLinkedin } from "react-icons/fa";
import { SantoshSir, AnkushSir, AsiSir, DevendraSir, john, MarkusDoetsch, MohanSir, ThomasLang, ArnfinnBlom, Ashok_Kumar, YaniSanaka, Smita, trupti } from '../../../theme/images';
import './Leadership.css';
// import { link } from '../../../../../backend/app/routes/authRoutes';

const management = [
    {
        name: 'Santosh Kotnis', role: 'Founder & CEO',
        img: SantoshSir,
        bio: "An experienced growth focused and global business executive with a solid track record of IT and business management experience that involves strategic planning, operations & financial management, program execution with complete P/L responsibility for the business units and organizations ranging from innovative start-up's to international leading organizations.",
        expertise: ["Strategic Planning", "Global Business", "P&L Management", "Operations", "Financial Management", "Business Growth"],
        quote: "Sustainable growth comes from disciplined execution and bold global vision.",
        linkedin: "https://www.linkedin.com/in/santoshkotnis/"
    },
    {
        name: 'Devendra Phadnis', role: 'Chief Technology Officer',
        img: DevendraSir,
        bio: "Devendra Phadnis is Chief Technology Officer (CTO) responsible leading and directing all technical aspects of our online presence. Mr. Phadnis has more than 22 years’ experience in Technical Architect and a core Member of Enterprise Solutions group and Pre-sales Group. Extensive working experience in Microsoft Platform along with specialization in Enterprise .NET Applications and SharePoint/ SharePoint Online. Currently, working on modern and advanced solutions based on Machine Learning, Data Analytics, BOTs, RPA and AR. Actively conduct training in the specialized technical areas such Enterprise Architecture, Blockchain & Cloud services such as Azure services",
        expertise: ["Enterprise Architecture", "Microsoft Platform", ".NET Development", "SharePoint", "Machine Learning", "Data Analytics", "RPA", "Azure Cloud", "Blockchain"],
        quote: "Innovation at scale is achieved by mastering the fundamentals and embracing emerging technologies.",
        linkedin: "https://www.linkedin.com/in/devendraphadnis/"

    },
    {
        name: 'Asi Sarath', role: 'Chief Digital Officer & Chief Architect',
        img: AsiSir,
        bio: "Asi is a technologist with extensive experience in end-to-end solutioning, encompassing System and Enterprise Architecture, Product Development, Cloud, and DevOps. He has successfully executed consulting assignments, including Roadmaps, Charters, and Maturity Assessments, for global customers. Asi's hunger for implementing innovative, high-performing solutions drives his passion for embracing new-age technologies.",
        expertise: ["Enterprise Architecture", "Solution Architecture", "Cloud Computing", "DevOps", "Product Development", "Digital Transformation", "Technology Roadmap", "Maturity Assessment"],
        quote: "Great solutions are born from deep architecture and a relentless drive for innovation.",
        linkedin: "https://www.linkedin.com/in/asi-sarath-r-9826519/"
    },
    {
        name: 'Ankush Kaje', role: 'Head of Cloud Practice',
        img: AnkushSir,
        bio: "Ankush, a cloud visionary with deep expertise in AWS, Azure, and GCP, leads our Cloud Practice. He crafts cutting-edge solutions that are not only scalable but also prioritize robust security. Ankush fosters a collaborative, high-performing team focused on innovation. His strategic thinking and industry knowledge empower businesses to leverage the cloud for agility, scalability, and cost-efficiency. Under Ankush's leadership, SpringUp Labs successfully migrated their complex data infrastructure to the cloud.",
        expertise: ["AWS", "Azure", "GCP", "Cloud Architecture", "Cloud Migration", "Cloud Security", "Multi-Cloud Strategy"],
        quote: "The cloud is not just infrastructure — it's a catalyst for business transformation and agility.",
        linkedin: "https://www.linkedin.com/in/ankush-kaje/"

    },
    {
        name: 'Smita Nalawade',
        role: 'Head of Human Resources',
        img: Smita,
        bio: "Smita is an accomplished HR leader with extensive experience in driving end-to-end people and talent strategies across diverse business environments. Her expertise spans Talent Acquisition, HR Operations, Employee Engagement, Performance Management, Learning & Development, Employee Relations, and Workforce Planning. She brings a strong understanding of business and customer requirements, enabling her to align people strategies with organizational priorities and growth. With a strategic and people-centric leadership approach, Smita focuses on building high-performing teams, strengthening organizational culture, and creating scalable HR practices. Her passion for developing talent, enabling employee growth, and partnering with business leaders drives her commitment to building an agile, engaged, and future-ready workforce.",
        expertise: [
            "Talent Acquisition",
            "HR Operations",
            "Employee Engagement",
            "Performance Management",
            "Learning & Development",
            "Employee Relations",
            "Workforce Planning",
            "Talent Management",
            "Organizational Culture"
        ],
        quote: "Building strong teams and a people-first culture for a future-ready organization.",
        linkedin: "https://www.linkedin.com/in/smita-nalawade-40045a265/overlay/contact-info/"
    },

    {
        name: 'Ashok Kumar Wadhwani',
        role: 'Head of Salesforce',
        img: Ashok_Kumar,
        bio: "Ashok Kumar Wadhwani is a technology and business leader with over 30 years of experience, spanning 18 years in IT and software technology and 12 years as an entrepreneur. He holds an MBA from IIM Bangalore and a B.Tech from NIT Nagpur, and brings deep expertise in Salesforce / VisualFabriq CRM, SaaS, digital transformation, and Agentic AI/GenAI — helping organizations translate technology investments into measurable business outcomes. Over his career, he has held leadership roles at Accenture, Cognizant, Altran, Mindteck, ABB, BOSE, Philips, and Bharat Electronics, where he led complex Salesforce CRM and SaaS programs across global markets and spearheaded Agentic AI and GenAI initiatives. At SpringUp Labs, he continues this focus by building innovative Salesforce, VisualFabriq and AI capabilities that create lasting value for customers.",
        expertise: [
            "Salesforce CRM",
            "VisualFabriq CRM",
            "SaaS",
            "Digital Transformation",
            "Agentic AI",
            "Generative AI",
            "Technology Leadership",
            "Business Strategy",
            "CRM Program Management",
            "Entrepreneurship"
        ],
        // quote: "Transforming technology investments into measurable business outcomes through innovation, leadership, and customer-focused solutions.",
        quote: "Turning technology into business value through innovation and customer-focused solutions.",
        linkedin: "https://www.linkedin.com/in/ashokwadhwani/"
    },
    {
        name: 'Yani Sanaka',
        role: 'Team Lead of Embedded Software',
        img: YaniSanaka,
        bio: "Yani Sanaka is an experienced engineering leader with 20 years in wireless communications, including 17 years in embedded software development at NEC Corporation. He holds an M.Tech. in Software Engineering and has extensive expertise in NEC PASOLINK, WiMAX, LTE eNodeB, iPASOLINK, and FPGA-based systems. Before joining the team, he served as a Senior Technical Architect at NEC Corporation India, Chennai, leading product development, system enhancements, and complex technical issue resolution. His strengths include software engineering, technical leadership, quality-focused development, and customer support.",
        expertise: [
            // "Embedded Software Development",
            "Wireless Communications",
            "NEC PASOLINK & iPASOLINK",
            "WiMAX & LTE",
            "FPGA-Based Systems",
            "Software Architecture",
            "Technical Leadership",
            "Product Development",
            "Quality Engineering",
            "Customer Support"
        ],
        quote: "Building reliable technology through engineering excellence, innovation, and customer-focused problem-solving.",
        linkedin: "https://www.linkedin.com/in/yani-sanaka-b5289113/"
    },
    {
        name: 'Trupthi Rokhade',
        role: 'Senior Manager of CPG Functional Solutions',
        img: trupti,
        bio: "Trupthi is a CPG domain expert with over 16 years of experience in Trade Promotion Management, Revenue Growth Management, and Market Research. She specializes in end-to-end solution design and implementation, leveraging platforms such as Visualfabriq and Xtel to optimize trade promotions, pricing, and revenue performance. With strong expertise in product management, digital transformation, and sales data analytics, she translates complex business data into actionable insights. Her experience in leading cross-functional teams helps bridge business needs with technology, delivering scalable solutions that improve operational efficiency and drive sustainable growth.",
        expertise: [
            "Trade Promotion Management",
            "Revenue Growth Management",
            "Market Research",
            "Visualfabriq",
            "Xtel",
            "CPG Functional Solutions",
            "Product Management",
            "Sales Data Analytics",
            "Digital Transformation",
            "Cross-Functional Leadership"
        ],
        quote: "Turning business insights into smarter decisions and sustainable growth.",
        linkedin: "https://www.linkedin.com/in/trupthi-rokhade-a212088/"
    }

];

const german = [
    {
        name: 'Thomas Lang', role: 'Chief Sales Officer',
        img: ThomasLang,
        bio: "An experienced growth focused and global business executive with a solid track record of IT and business management experience that involves strategic planning, operations & financial management, program execution with complete P/L responsibility for the business units and organizations ranging from innovative start-up's to international leading organizations.",
        expertise: ["Global Sales", "Strategic Planning", "P&L Management", "Business Growth", "Operations", "Financial Management", "Enterprise Sales", "DACH Markets"],
        quote: "Long-term success is built on trust, strategic execution, and a relentless focus on growth.",
        linkedin: "https://www.linkedin.com/in/thomas-lang-9750271b5/"
    },
    {
        name: 'Markus Doetsch', role: 'Chief Technology Officer',
        img: MarkusDoetsch,
        bio: "An experienced growth focused and global business executive with a solid track record of IT and business management experience that involves strategic planning, operations & financial management, program execution with complete P/L responsibility for the business units and organizations ranging from innovative start-up's to international leading organizations.",
        expertise: ["Technology Strategy", "Strategic Planning", "P&L Management", "Innovation Leadership", "Operations", "Business Growth", "EU Market"],
        quote: "True innovation happens at the intersection of vision, execution, and customer focus.",
        linkedin: "https://www.linkedin.com/in/markusdoetsch/"
    }
];

const heads = [
    {
        name: 'Mohan Sahota', role: 'Vice President - UK',
        img: MohanSir,
        bio: 'Purposeful and accomplished professional with a diverse background in entrepreneurship, business start-ups, mentoring, board membership, advisory roles, directorship, and business development. Equipped with extensive knowledge and expertise in IT, SaaS solutions, and software solution sales. Proven track record of building strong business relationships with leading corporations in the UK and international markets.',
        expertise: ['Client Success', 'Growth'],
        quote: 'Listen first, deliver always.',
        linkedin: "https://www.linkedin.com/in/mohan-sahota-0344603/"
    },
    {
        name: 'Arnfinn Blom', role: 'General Manager - Nordics',
        img: ArnfinnBlom,
        bio: 'With over 30 years of experience in sales, sales management, and executive leadership, this career has been solid both nationally and internationally, especially within the technology sector and digital solutions (SaaS).Experience ranges from startups to leading positions in established companies, achieving excellent results through strategic business development and efficient operational management.Technical education and a business economist from the University of South-Eastern Norway.',
        expertise: ['Nordics', 'Partnerships'],
        quote: 'Long winters teach patience and craft.',
        linkedin: "https://www.linkedin.com/in/arnfinn-kilden-blom-9ab4b3/"
    },
    {
        name: 'John Relic', role: 'President, Healthcare - UK',
        img: john,
        bio: 'John is Successful Healthcare Leader with more than 40 years in Hospital, Medical Group, Medical Practice, and entrepreneur executive leadership and consultant. A proven history of, developing new businesses and strategies, leading large projects, and developing people to implement long-term, self-sustaining change processes with a keen focus on quality patient care, revenue enhancement, and operational excellence. Created new revenue streams above $250 Million.John’s recent experience was, Chief Operating Officer(2018- 2022) of a new healthcare start - up.Responsible for operations, budget, staffing, client services, and development.Focused on the delivery of patient services, to State Health Plans, Hospitals Health systems, and community - based care organizations.Currently, he is CEO of Health Innovative Solutions which brings new technologies to the healthcare landscape to reshape current practices and operations by bringing leading - edge technologies and solutions to solve large - scale inadequacies.John will be based out in Austin, Texas and will be leading our HealthCare business.',
        expertise: ['Healthcare', 'Life Sciences'],
        quote: 'Healthcare deserves software that earns trust.',
        linkedin: "https://www.linkedin.com/in/jrelic/"
    },
];

const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.08, duration: 0.55, ease: [0.25, 0.46, 0.45, 0.94] } }),
};

const LeaderCard = ({ leader, i, onOpen }) => (
    <motion.article
        className="ld-card"
        custom={i}
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-50px' }}
    >
        <span className="ld-corner ld-corner--tl" />
        <span className="ld-corner ld-corner--br" />
        <div className="ld-card__photo">
            <img src={leader.img} alt={leader.name} loading="lazy" />
            <div className="ld-card__shine" />
        </div>
        <div className="ld-card__body">
            <div className="ld-card__meta">
                <h3 className="ld-card__name">{leader.name}</h3>
                <p className="ld-card__role">{leader.role}</p>
            </div>
            <button className="ld-card__cta" aria-label={`View ${leader.name} details`} onClick={() => onOpen(leader)}>
                <ArrowUpRight />
            </button>
        </div>
    </motion.article>
);

const Section = ({ title, eyebrow, leaders, onOpen }) => (
    <section className="ld-section">
        <div className="ld-container">
            <motion.div className="ld-section__head" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} custom={0}>
                <span className="ld-eyebrow"><Sparkles size={14} /> {eyebrow}</span>
                <h2 className="ld-section__title">{title}</h2>
            </motion.div>
            <div className="ld-grid">
                {leaders.map((l, i) => <LeaderCard key={l.name} leader={l} i={i} onOpen={onOpen} />)}
            </div>
        </div>
    </section>
);

const Modal = ({ leader, onClose }) => (
    <motion.div className="ld-modal__overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose}>
        <motion.div
            className="ld-modal"
            initial={{ opacity: 0, y: 40, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 30, scale: 0.96 }}
            transition={{ duration: 0.35, ease: [0.25, 0.46, 0.45, 0.94] }}
            onClick={(e) => e.stopPropagation()}
        >
            <button className="ld-modal__close" onClick={onClose} aria-label="Close"><X /></button>
            <div className="ld-modal__grid">
                <div className="ld-modal__photo">
                    <img src={leader.img} alt={leader.name} />
                    <div className="ld-modal__photoBadge">{leader.role.split(' ').slice(0, 1)}</div>
                </div>
                <div className="ld-modal__content">
                    <span className="ld-eyebrow"><Sparkles size={14} /> Leadership</span>
                    <h3 className="ld-modal__name">{leader.name}</h3>
                    <p className="ld-modal__role">{leader.role}</p>
                    <p className="ld-modal__bio">{leader.bio}</p>
                    <div className="ld-modal__quote">
                        <Quote className="ld-modal__quoteIcon" />
                        <p>{leader.quote}</p>
                    </div>
                    <div className="ld-modal__chips">
                        {leader.expertise.map((tag) => <span key={tag} className="ld-chip">{tag}</span>)}
                    </div>
                    <div className="ld-modal__actions">
                        {leader.linkedin ? (
                            <a
                                href={leader.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="ld-modal__btn ld-modal__btn--primary"
                            >
                                <FaLinkedin size={16} /> Connect
                            </a>
                        ) : (
                            <button className="ld-modal__btn ld-modal__btn--primary" type="button" disabled>
                                <FaLinkedin size={16} /> Connect
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </motion.div>
    </motion.div>
);

const Leadership = () => {
    const [active, setActive] = useState(null);
    return (
        <div className="ld-page">
            {/* HERO */}
            <section className="ld-hero">
                <div className="ld-hero__grid" />
                <div className="ld-hero__blob ld-hero__blob--a" />
                <div className="ld-hero__blob ld-hero__blob--b" />
                <div className="ld-hero__blob ld-hero__blob--c" />

                <div className="ld-hero__orbit" aria-hidden="true">
                    {[
                        SantoshSir, DevendraSir, AsiSir,
                        AnkushSir, ThomasLang, MarkusDoetsch, Smita,
                        MohanSir, ArnfinnBlom, john, Ashok_Kumar, YaniSanaka,

                    ].map((imgSrc, i) => (
                        <motion.div
                            key={i}
                            className={`ld-hero__avatar ld-hero__avatar--${i}`}
                            initial={{ opacity: 0, scale: 0.6 }}
                            animate={{ opacity: 1, scale: 1, y: [0, -10, 0] }}
                            transition={{ delay: 0.4 + i * 0.06, duration: 4 + (i % 3), repeat: Infinity, repeatType: 'reverse', ease: 'easeInOut' }}
                        >
                            <img src={imgSrc} alt="" />
                        </motion.div>
                    ))}
                </div>

                <div className="ld-container ld-hero__inner">
                    <motion.span className="ld-eyebrow" initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}>
                        <Sparkles size={14} /> Our Leadership
                    </motion.span>
                    {/* <motion.h1 className="ld-hero__title" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}>
                        The minds behind <br /><span className="ld-hero__accent">Springup's bold journey</span>
                    </motion.h1> */}
                    <motion.h1 className="ld-hero__title" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}>
                        Meet Our Leaders And <br /><span className="ld-hero__accent">Global Management
                            Team</span>
                    </motion.h1>
                    <motion.p className="ld-hero__sub" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>
                        Visionary founders, technologists and operators — guiding our teams across continents
                        with conviction, craft and heart.
                    </motion.p>

                    {/* <motion.div className="ld-hero__stats" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}>
                        <div><strong>25+</strong><span>Years Experience</span></div>
                        <div className="ld-hero__statDiv" />
                        <div><strong>11</strong><span>Global Leaders</span></div>
                        <div className="ld-hero__statDiv" />
                        <div><strong>4</strong><span>Continents</span></div>
                    </motion.div> */}
                </div>
            </section>
            <Section eyebrow="Management Team" title="Driving the vision forward" leaders={management} onOpen={setActive} />
            <Section eyebrow="German Management" title="Leading our European expansion" leaders={german} onOpen={setActive} />
            <Section eyebrow="Business Heads" title="Owning outcomes across regions" leaders={heads} onOpen={setActive} />
            <AnimatePresence>
                {active && <Modal leader={active} onClose={() => setActive(null)} />}
            </AnimatePresence>
        </div>
    );
};

export default Leadership;